import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IUser } from './types/IUser';

import { ApiService } from './api.service';

@Injectable()
export class AdminsApiService {
  constructor(private apiService: ApiService) {}

  getAdminAssociatedToToken(): Observable<IUser> {
    return this.apiService.get('/admins');
  }

  getByTenant(id: string): Observable<any> {
    return this.apiService.get(`/tenants/${id}/admins/`);
  }

  updateUser(user: { id: string }): Observable<any> {
    return this.apiService.put(`/admins/${user.id}`, user);
  }

  delete(admin: { id: string }, password: string): Observable<any> {
    return this.apiService.delete(`/admins/${admin.id}`, {
      password,
    });
  }

  inviteAdmin(admin): Observable<any> {
    return this.apiService.post('/admins/', admin);
  }

  createPassword(admin): Observable<any> {
    return this.apiService.post('/admins/password', admin);
  }

  requestPasswordReset(admin): Observable<any> {
    return this.apiService.post('/admins/requestPasswordReset', admin);
  }

  resetPassword(admin): Observable<any> {
    return this.apiService.post('/admins/password', admin);
  }

  checkToken(admin: { token: string }): Observable<any> {
    return this.apiService.get(`/admins/token/${admin.token}`);
  }
}
